import React, { useState } from 'react';
import { LinearProgress, Box, Typography } from '@mui/material';
import { parseISO, format, differenceInCalendarDays } from 'date-fns';
import { es } from 'date-fns/locale'; // Importa el locale español

const ProgressBar = ({ idGrupo, barColor }) => {
  const [hover, setHover] = useState(false);

  if (!idGrupo) {
    return (
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={215}
        margin="0 auto"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <LinearProgress
          variant="determinate"
          value={100}
          sx={{ 
            height: 25, 
            width: '100%',
            borderRadius: 5,
            bgcolor: '#ccc', 
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#a2a29c', 
            }
          }}
        />
        <Typography
          variant="body2"
          component="div"
          color="white"
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          -
        </Typography>
      </Box>
    );
  }

  const { fecha_inicio: startDate, fecha_final: endDate, dias_transcurridos: daysPassedFromApi } = idGrupo;

  const currentDate = new Date();
  let start, end, progress, startFormatted, endFormatted, progressBarColor;

  if (startDate && endDate) {
    start = parseISO(startDate);
    end = parseISO(endDate);

    const totalDays = differenceInCalendarDays(end, start);
    const daysPassed = Math.max(differenceInCalendarDays(currentDate, start), 0); // Asegúrate de no tener valores negativos

    progress = (daysPassed / totalDays) * 100;

    // Formatear las fechas en español
    const formatOptions = { day: 'numeric', month: 'short' };
    startFormatted = format(start, 'd MMM', { locale: es });
    endFormatted = format(end, 'd MMM', { locale: es });

    progressBarColor = barColor || '#76c7c0';
  } else {
    progress = 100;
    startFormatted = '-';
    endFormatted = '-';
    progressBarColor = '#a2a29c';
  }

  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);

  return (
    <Box
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      width={215}
      margin="0 auto"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ 
          height: 25, 
          width: '100%',
          borderRadius: 5,
          bgcolor: '#ccc', 
          '& .MuiLinearProgress-bar': {
            backgroundColor: progressBarColor,
          }
        }}
      />
      <Typography
        variant="body2"
        component="div"
        color="white"
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {hover ? `${daysPassedFromApi || '-'}` : `${startFormatted} - ${endFormatted}`}
      </Typography>
    </Box>
  );
};

export default ProgressBar;
